export const initialState = {
  getOfficeBranches: {
    loading: false,
    success: false,
    error: false,
    data: null,
  },
};
